import React from 'react';
import PageLayout from './ui/PageLayout';
import AddTagPage from './AddTagPage';

/**
 * Standalone Add Tag page with Sidebar + PageLayout.
 * Used when rendered at /add-tag route.
 */
const AddTagPageWrapper = () => (
  <PageLayout>
    <AddTagPage />
  </PageLayout>
);

export default AddTagPageWrapper;
